import {IValtioModel} from "@/shared/models/base-model.interface";
import {type InfoCardProps} from "@/shared/ui/data-display/cards/info-card";

export abstract class BaseBlogsModelClass implements IValtioModel {
    // State
    posts: Array<InfoCardProps> = [];
    isLoading: boolean = false;
    isButtonLoading: boolean = false;
    pageSize: number = 8;
    private _hasMore: boolean = false;

    protected constructor(pageSize: number = 8) {
        this.pageSize = pageSize;
    }

    get hasMore(): boolean {
        return this._hasMore;
    }

    set hasMore(value: boolean) {
        this._hasMore = value;
    }

    abstract init(): void;
    abstract loadMore(): void | Promise<void>;

    updatePosts(newPosts: Array<InfoCardProps>, hasMore: boolean): void {
        this.posts = newPosts;
        this.hasMore = hasMore;
        this.isLoading = false;
        this.isButtonLoading = false;
    }

    dispose(): void {
        /* empty */
    }
}
